import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./CouponCode.module.scss";
import { AiOutlineCheck } from "@react-icons/all-files/ai/AiOutlineCheck";
import CustomButton from "../customButton/CustomButton";
import { selectCouponCode } from "../../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import { useAppSelector } from "../../hooks/reduxHooks";
import CustomCheckbox from "../customCheckbox/CustomCheckbox";
import { selectCouponCodeValid } from "../../redux/slices/propertySlice/PropertySlice.selectors";
import { Box, Input } from "@mui/material";

interface Props {
  onApply: (couponCode: string) => void;
  loading: boolean;
}

enum ApplyState {
  APPLIED = "APPLIED",
  DEFAULT = "DEFAULT",
  INVALID = "INVALID",
  UNCHECKED = "UNCHECKED",
}

const CouponCode: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const couponCodeValid = useAppSelector(selectCouponCodeValid);
  const couponCode = useAppSelector(selectCouponCode);

  const [couponCodeInput, setCouponCodeInput] = useState<string>(
    couponCode ?? ""
  );
  const [applyState, setApplyState] = useState(
    couponCode ? ApplyState.APPLIED : ApplyState.UNCHECKED
  );

  useEffect(() => {
    if (!couponCode) return;
    setCouponCodeInput(couponCode);
    if (props.loading) return;
    if (!couponCodeValid) return setApplyState(ApplyState.INVALID);
    setApplyState(ApplyState.APPLIED);
  }, [couponCode, props.loading, couponCodeValid]);

  return (
    <div className={styles.promoCode}>
      {applyState === ApplyState.UNCHECKED ? (
        <div>
          <CustomCheckbox
            label={t("labels.couponCode")}
            name="couponCode"
            onChange={(checked) => {
              if (!checked) return;
              setApplyState(ApplyState.DEFAULT);
            }}
          />
        </div>
      ) : (
        <>
          <div className={styles.title}>{t("labels.couponCode")}</div>
          <Input
            value={couponCodeInput}
            error={applyState === ApplyState.INVALID}
            onChange={(e) => {
              setApplyState(ApplyState.DEFAULT);
              setCouponCodeInput(e.target.value);
            }}
            startAdornment={
              <Box sx={{ marginRight: ".25rem" }}>
                {(applyState === ApplyState.INVALID && (
                  <img
                    src="https://booking.availroom.com/v2/assets/icons/redCross.svg"
                    alt="icon"
                  />
                )) ||
                  (applyState === ApplyState.APPLIED && (
                    <AiOutlineCheck size={"1.3em"} color="green" />
                  )) || (
                    <img
                      src="https://booking.availroom.com/v2/assets/icons/percentage.svg"
                      alt="icon"
                    />
                  )}
              </Box>
            }
          />
          <div className={styles.applyBtnContainer}>
            <CustomButton
              onClick={() => props.onApply(couponCodeInput)}
              backgroundColor="white"
              borderColor={
                applyState === ApplyState.INVALID
                  ? "red"
                  : applyState === ApplyState.APPLIED
                  ? "green"
                  : undefined
              }
              className={`${styles.applyBtn} ${
                applyState === ApplyState.APPLIED && styles.applyBtn_success
              } ${
                applyState === ApplyState.INVALID && styles.applyBtn_invalid
              }`}
              disabled={props.loading}
            >
              {(applyState === ApplyState.INVALID &&
                t("property.couponCode.button.invalid")) ||
                (applyState === ApplyState.APPLIED &&
                  t("property.couponCode.button.applied")) ||
                t("property.couponCode.button.default")}
            </CustomButton>
          </div>
        </>
      )}
    </div>
  );
};
export default CouponCode;
